// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__Irvy6","footer":"ModalError_footer__1ylmn"};